import { render, staticRenderFns } from "./quickmenuNotification.vue?vue&type=template&id=57cc5872&scoped=true&lang=pug&"
import script from "./quickmenuNotification.vue?vue&type=script&lang=js&"
export * from "./quickmenuNotification.vue?vue&type=script&lang=js&"
import style0 from "./quickmenuNotification.vue?vue&type=style&index=0&id=57cc5872&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57cc5872",
  null
  
)

export default component.exports